import Vue from '@/index.js'
import './cart.scss'

import page from '@/mixins/page'

import VueSuggestion from 'vue-suggestion';
Vue.use(VueSuggestion);

export default new Vue({
  el: '#app',
  mixins: [page],
  data() {
    return {
      quickBuy: false
    }
  },
  components: {
    //Autocomplete,
    'layout-cart-header': () => import('@/components/layout/cart/layout-cart-header.vue'),
    'layout-cart-page': () => import('@/components/layout/cart/layout-cart-page.vue'),
    'layout-cart-result': () => import('@/components/layout/cart/layout-cart-result.vue'),
    'layout-cart-products': () => import('@/components/layout/cart/layout-cart-products.vue'),
    'layout-cart-paysystems': () => import('@/components/layout/cart/layout-cart-paysystems.vue'),
    'layout-cart-relative-goods': () => import('@/components/layout/cart/layout-cart-relative-goods.vue'),
    'layout-cart-form': () => import('@/components/layout/cart/layout-cart-form.vue'),
    'layout-cart-success': () => import('@/components/layout/cart/layout-cart-success.vue'),
    'layout-popup': () => import('@/components/layout/layout-popup.vue'),
    'ui-button': () => import('@/components/ui/ui-button.vue'),
    'layout-data-popup-map':() => import('@/components/layout/layout-data-popup-map.vue'),
  }
})
